import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Menu, MenuItem, Tooltip } from "@mui/material";
import Flag, { flagCodeType } from "national-flag-icons";
import { i18n } from "i18next";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const resolveFlagLanguage = (input: i18n) => {
    const twoLetterLang = input.language.split("-")[0];
    if (twoLetterLang === "cs") {
        return "cz";
    } else if (twoLetterLang === "en") {
        return "gb";
    }
    return twoLetterLang;
};

const resolveLanguageText = (input: i18n) => {
    const twoLetterLang = input.language.split("-")[0];
    if (twoLetterLang === "cs") {
        return "Čeština";
    } else if (twoLetterLang === "en") {
        return "English";
    }
};

export default function LocalizationSwitcher({
    anchorEl,
    setAnchorEl,
}: {
    setAnchorEl: React.Dispatch<null | HTMLElement>;
    anchorEl: null | HTMLElement;
}) {
    const { i18n } = useTranslation();
    const open = Boolean(anchorEl);

    const handleClose = (e: React.MouseEvent | { preventDefault?: () => unknown; stopPropagation?: () => unknown }) => {
        setAnchorEl(null);
        e?.preventDefault?.();
        e?.stopPropagation?.();
    };

    const onChangeLanguage = (e: React.MouseEvent, language: string) => {
        i18n.changeLanguage(language);
        handleClose(e);
        location.reload();
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Tooltip title={i18n.t("common.changeLanguage")}>
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                    <Typography sx={{ flexGrow: 1 }} variant="body1">
                        {resolveLanguageText(i18n)}
                    </Typography>
                    <Flag flagCode={resolveFlagLanguage(i18n) as flagCodeType} />
                </Stack>
            </Tooltip>
            <Menu id="localeMenu" anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={(e) => onChangeLanguage(e, "cs")}>
                    <ListItemIcon>
                        <Flag flagCode="cz" />
                    </ListItemIcon>
                    <ListItemText>Čeština</ListItemText>
                </MenuItem>
                <MenuItem onClick={(e) => onChangeLanguage(e, "en")}>
                    <ListItemIcon>
                        <Flag flagCode="gb" />
                    </ListItemIcon>
                    <ListItemText>English</ListItemText>
                </MenuItem>
            </Menu>
        </Box>
    );
}